export const DataIcon = () => (
  <svg width="48" height="48" viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <ellipse cx="24" cy="12" rx="14" ry="5" stroke="#B8860B" strokeWidth="1.5" fill="none"/>
    <path d="M10 12V18C10 20.76 16.27 23 24 23C31.73 23 38 20.76 38 18V12" stroke="#B8860B" strokeWidth="1.5" fill="none"/>
    <path d="M10 18V24C10 26.76 16.27 29 24 29C31.73 29 38 26.76 38 24V18" stroke="#B8860B" strokeWidth="1.5" fill="none"/>
    <path d="M10 24V30C10 32.76 16.27 35 24 35C31.73 35 38 32.76 38 30V24" stroke="#B8860B" strokeWidth="1.5" fill="none"/>
    <path d="M10 30V36C10 38.76 16.27 41 24 41C31.73 41 38 38.76 38 36V30" stroke="#B8860B" strokeWidth="1.5" opacity="0.5" fill="none"/>
  </svg>
);
